import { Dispatch } from 'redux';
import { StoreState } from '../store-interfaces';
import { NOT_FOUND } from '@mm/constants/status-codes';
import commonHandler, { ResponseOrError } from './common-handler';
import AffiliatesCRUDActions from '../actions/AffiliatesCRUDActions';

export default (dispatch: Dispatch<StoreState>) =>
  async (error: ResponseOrError) => {
    if (error instanceof Response && error.status === NOT_FOUND) {
      dispatch(AffiliatesCRUDActions.unbusy());
    } else {
      commonHandler(dispatch)(error);
    }
  };
